<template>
  <div class="UserMemberIcons demand-user">
    <img :src="avatar" alt="" class="demand-user-avatar">
    <div class="demand-user-id">{{ item.uid }}</div>
    <div class="demand-user-vip" v-if="item.curr_vip_type && item.curr_vip_type.length">
      <i class="member-person" v-if="item.curr_vip_type.indexOf(1) > -1 "></i>
      <i class="member-business" v-if="item.curr_vip_type.indexOf(2) > -1 "></i>
      <i class="member-company" v-if="item.curr_vip_type.indexOf(3) > -1 "></i>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "UserMemberIcons",
  props: {
    uid: {
      type: String | Number,
      default: '88888888'
    },
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState('user', ['avatar'])
  }
}
</script>

<style lang="scss" scoped>
.demand-user {
  display: flex;
  align-items: center;

  .demand-user-avatar {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.6);
  }

  .demand-user-id {
    height: 17px;
    font-size: 13px;
    color: #596080;
    line-height: 17px;
    margin: 0 4px 0 8px;
  }

  .demand-user-vip {

    .member-person {
      //@include BgImage(22px, 22px, $member-person);
      @include IconVip(1,22,22)
    }

    .member-business {
      //@include BgImage(22px, 22px, $member-business);
      @include IconVip(1,22,22)
    }

    .member-company {
      //@include BgImage(22px, 22px, $member-company);
      @include IconVip(2,22,22)
    }
  }

}
</style>
